var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-50",
    "data-name": "50_Kids_Icons-50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5122",
    "data-name": "Group 5122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5109",
    "data-name": "Group 5109",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M152.947,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,244.065,152.947,246.493Z",
    transform: "translate(-123.38 -204.934)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M320,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,244.065,320,246.492Z",
    transform: "translate(-269.567 -204.934)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5110",
    "data-name": "Group 5110",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M128.4,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.397 -326.964)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5111",
    "data-name": "Group 5111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M226.979,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -214.962)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5113",
    "data-name": "Group 5113",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5112",
    "data-name": "Group 5112",
    transform: "translate(26.617 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M197.113,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923a10.422,10.422,0,0,1-10.422-10.422V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-170.346 -115.884)",
    fill: "#ffdbc5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5114",
    "data-name": "Group 5114",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5115",
    "data-name": "Group 5115",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M162.019,144.564l.6-5.3a5.563,5.563,0,0,1,5.527-4.933h13.1a5.563,5.563,0,0,1,5.527,4.932l.605,5.3h1.521a18.707,18.707,0,0,0,.85-5.6c0-9.326-6.74-16.886-15.055-16.886s-15.055,7.56-15.055,16.886a18.707,18.707,0,0,0,.85,5.6Z",
    transform: "translate(-134.703 -103.002)",
    fill: "#cc7352"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5116",
    "data-name": "Group 5116",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M244.43,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,279.542Z",
    transform: "translate(-202.216 -235.864)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5117",
    "data-name": "Group 5117",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M128.39,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -339.904)",
    fill: "#966796"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5118",
    "data-name": "Group 5118",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(45.469 43.107)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(28.281 43.107)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5119",
    "data-name": "Group 5119",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M229.511,310.367a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-186.267 -261.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5120",
    "data-name": "Group 5120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M331.092,165.216l1.828.021.055-16.02-3.768-2.64Z",
    transform: "translate(-277.768 -123.674)",
    fill: "#cc7352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M158.7,164.822l1.828.021,2.017-18.6-3.872,2.554Z",
    transform: "translate(-133.882 -123.397)",
    fill: "#cc7352"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5121",
    "data-name": "Group 5121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 15.625,
    cy: 7.813,
    rx: 15.625,
    ry: 7.813,
    transform: "translate(24.375 16.563)",
    fill: "#cc7352"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar5.a9451fcee45e9b2d89df6dd2906cc316.svg";
export { ForwardRef as ReactComponent };